import { Grid } from '@mui/material'

import GridIconButton from './GridIconButton'

const GridWeeklyTimeSlot = ({ index, x, values, onChange = () => {} }) => {
  const removeIndex = () =>
    onChange([...values?.slice(0, index), ...values?.slice(index + 1)])

  return (
    <Grid container alignItems='center' sx={{ width: '100%' }}>
      <Grid size={{ xs: 10, md: 5 }}>
        {x.giorno} dalle {x.dalle} alle {x.alle}
      </Grid>
      <GridIconButton
        type='delete'
        size={{ xs: 2, md: 1 }}
        onClick={removeIndex}
      />
    </Grid>
  )
}

export default GridWeeklyTimeSlot
